import UAParser from 'ua-parser-js'

// Detect OS to use
export default function detectOS() {

    // Parse user agent
    let ua = UAParser()
    console.log(ua)
    if (ua.os.name == 'Android')
        return 'android'
    if (ua.os.name == 'iOS')
        return 'ios'
    if (ua.os.name == 'Mac OS' && navigator.maxTouchPoints > 2)
        return 'ios'    // HACK: iPad OS 13 has "desktop mode" turned on by default for all websites now. Thanks, Apple.
    if (ua.os.name == 'Mac OS')
        return 'macOS'
    if (ua.os.name == 'Windows' && ua.os.version >= '10')
        return 'windowsUniversal'
    if (ua.os.name == 'Windows')
        return 'windowsLegacy'

    // Other, use generic Java version
    return 'linux'

}
